import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import ProductInfoDetails from "../../../features/Product/ProductInfoDetails";
import { useLazyGetProductByIdQuery } from "../../../services/products";
import { ProductType } from "../../../types/General";
import { errorToast } from "../../../helpers";
import Loader from "../../../helpers/constants/Loader";
import useTranslation from "../../../hooks/Translation";

const ProductDetails = () => {
  const { _id } = useParams();
  const t = useTranslation();

  const navigate = useNavigate();
  const { state } = useLocation();
  console.log(state, "state");
  const [value, setValue] = React.useState(0);
  const [getDetails] = useLazyGetProductByIdQuery();
  const [productData, setProductData] = useState<ProductType>();

  const [loading, setLoading] = useState(false);

  const getProductById = async (id: any) => {
    setLoading(true);
    try {
      const res = await getDetails({ id }).unwrap();
      if (res?.status === 200) {
        setProductData(res?.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      console.log(error, "errror");
      setLoading(false);
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (_id) {
      getProductById(_id);
    }
  }, [_id]);

  useLayoutEffect(() => {
    if (state) {
      setValue(state);
    }
  }, []);
  return (
    <div>
      <Loader loading={loading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.main.productDetails}</h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-products", { state: state });
            }}
          >
            {t.main.back}
          </Button>
        </div>

        <ProductInfoDetails productData={productData} />
      </div>
    </div>
  );
};

export default ProductDetails;
